import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {UnsubscribeProduct} from '../../models/unsubscribe-product';

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeListService {

  constructor(private apiClient: ApiClientService) {
  }

  findByEmail(email: string): Observable<UnsubscribeProduct[]> {
    return new Observable<UnsubscribeProduct[]>((subscriber: Subscriber<UnsubscribeProduct[]>): void => {
      this.apiClient.post('/unsubscribe-list/email', {}, {email}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData().map((data: any) => new UnsubscribeProduct().deserialize(data)));
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
